(function () {
    'use strict';

    angular
        .module('app.core')
        .factory('culture', culture);

    culture.$inject = ['$q', '$locale', 'gettextCatalog', 'tmhDynamicLocale', '$timeout'];
    function culture($q, $locale, gettextCatalog, tmhDynamicLocale, $timeout) {
        return { set: set, get: get };

        function get() {
            if (!$locale.normalizedId) 
                $locale.normalizedId = $locale.localeID.replace('_', '-')
            return $locale.normalizedId;
        }

        function set(value) {
            value = value && value.toLowerCase();
            return value !== get()
                ? $q.all([gettextCatalog.loadLanguage(value), tmhDynamicLocale.loadLanguage(value)]).then(success)
                : $q.resolve();

            function success() {
                gettextCatalog.setCurrentLanguage(value);
                tmhDynamicLocale.set(value);
                return $timeout(angular.noop, 0, false);
            }
        }
    }
})();